import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';

import { createEffectFactory } from '@recruitee/ngrx';

import { DeletionRequestsHttpClient } from './deletion-requests-http-client';
import { DeletionRequestsActions } from './deletion-requests.store';

@Injectable({ providedIn: 'root' })
export class DeletionRequestsEffects {
  public effects = createEffectFactory(DeletionRequestsActions, this.actions$);

  public fetchAccountDeletionRequestCollection$ = this.effects(DeletionRequestsActions.fetch, () =>
    this.deletionRequestsService.fetchDeletionRequests(),
  );

  constructor(
    private deletionRequestsService: DeletionRequestsHttpClient,
    private actions$: Actions,
  ) {}
}
